// eslint-disable-next-line import/prefer-default-export
export const SNACKBAR_MESSAGE = 'SNACKBAR_MESSAGE';
